import script from "./SageBackup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SageBackup.vue?vue&type=script&setup=true&lang=ts"

import "./SageBackup.vue?vue&type=style&index=0&id=272a40e9&lang=css"

const __exports__ = script;

export default __exports__